import { createContext, useCallback, useContext, useMemo } from 'react';
import { isFunction } from '@mews/std';
import { OptimusTextKey } from '../OptimusTextKey';
import { ILocalizationContext, LocalizationProviderProps, TranslationOptions } from '../types';

export const LocalizationContext = createContext<ILocalizationContext>({
    t: () => '',
});

LocalizationContext.displayName = 'LocalizationContext';

const LocalizationProvider = ({ children, localizationTexts }: LocalizationProviderProps) => {
    const getTranslation = useCallback(
        (optimusTextKey: OptimusTextKey, options?: TranslationOptions) => {
            const translation = localizationTexts[optimusTextKey];

            if (isFunction(translation)) {
                return translation(options);
            }

            return translation;
        },
        [localizationTexts]
    );

    return (
        <LocalizationContext.Provider value={useMemo(() => ({ t: getTranslation }), [getTranslation])}>
            {children}
        </LocalizationContext.Provider>
    );
};

const useLocalization = () => useContext(LocalizationContext);

export { LocalizationProvider, useLocalization };
